import { defineComponent, provide, h } from 'vue';

const kebabToCamelCase = (s) => s.replace(/-./g, (x) => x.toUpperCase()[1]);
const wrapChartOnRender = (options, internal) => {
  var _a, _b, _c, _d, _e;
  if ((_b = (_a = options.chart) == null ? void 0 : _a.events) == null ? void 0 : _b.render) {
    const orig = options.chart.events.render;
    return {
      ...options,
      chart: {
        ...options.chart,
        events: {
          ...options.chart.events,
          render(event) {
            internal.call(this, event);
            orig.call(this, event);
          }
        }
      }
    };
  }
  return {
    ...options,
    chart: {
      ...(_c = options.chart) != null ? _c : {},
      events: {
        ...(_e = (_d = options.chart) == null ? void 0 : _d.events) != null ? _e : {},
        render: internal
      }
    }
  };
};
const internalComponentDefinition = (componentName, configuration, widget) => {
  return defineComponent({
    inheritAttrs: true,
    name: widget.__name,
    setup(props, context) {
      Object.entries(configuration).forEach(([key, value]) => {
        provide(key, value);
      });
      return () => h(`${componentName}-internal`, { props, ...context, scopedSlots: context.slots, on: context.listeners });
    },
    components: { [`${componentName}-internal`]: widget }
  });
};

export { internalComponentDefinition, kebabToCamelCase, wrapChartOnRender };
